<template>
  <div v-if="svgIcon" class="inline-block align-middle">
    <span :class="svgFill" v-html="svgIcon"></span>
  </div>
</template>

<script>
import Icons from "../utils/iconUtils.js";
export default {
  name: "SvgIcon",
  props: {
    iconName: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    svgFill: {
      type: String,
      default: "fill-gray-1"
    }
  },
  computed: {
    svgIcon() {
      const key = this.iconName || this.name;
      return Icons[key] || "";
    }
  }
};
</script>